var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5353 14.5578L29.972 13.1773V12.875H24.9962L21.4501 21.7438L17.4165 12.875H12.1993V13.1773L13.8775 15.207C14.0415 15.357 14.1259 15.5773 14.1048 15.7977V23.7734C14.1564 24.0617 14.065 24.3547 13.8634 24.5633L11.972 26.8672V27.1648H17.3298V26.8625L15.4407 24.5656C15.3395 24.4629 15.2634 24.3381 15.2183 24.2011C15.1731 24.0641 15.1602 23.9186 15.1806 23.7758V16.8758L19.8845 27.1695H20.4306L24.4759 16.8758V25.0766C24.4759 25.2922 24.4759 25.3367 24.3353 25.4797L22.8798 26.893V27.1953H29.9392V26.893L28.5353 25.5125C28.4134 25.4188 28.3501 25.2617 28.3759 25.1094V14.9609C28.3638 14.8856 28.3722 14.8084 28.4002 14.7375C28.4282 14.6665 28.4749 14.6045 28.5353 14.5578Z",
    fill: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.ef560137.svg";
export { ForwardRef as ReactComponent };